import { MDSBanner, MDSBannerKind, MDSBannerSlotName, MDSButton } from "@/mds";
import { MdsIconKind } from "@/design-system/components/icon";
import { FeatureGateBannerProps, FeatureGateBannerQuotaLevel } from "./feature-gate-banner.types";
import { getFeatureGateBannerConfig } from "./feature-gate-banner.config";

import { GatedFeature } from "@/store/feature-gates/types";
import { useAppStore } from "@/store";
import { useTheme } from "@emotion/react";
import { trackEvent } from "@/domains/metrics/segment";
import { TrackedEvent } from "@/domains/metrics/tracked-event";
import { useEffectOnMount } from "@/domains/react/useEffectOnMount";

export const FeatureGateBannerDisplay = ({
  level = FeatureGateBannerQuotaLevel.Warning,
}: FeatureGateBannerProps) => {
  const theme = useTheme();
  const { store } = useAppStore();

  const { bannerKind, message, buttonVariant, buttonText, iconKind } =
    getFeatureGateBannerConfig(level);

  const handleButtonClick = () => {
    trackEvent(TrackedEvent.FeatureGateBannerUpgradeClick, { level });
    store.subscriptions.openUsageLimitUpsell({
      feature: GatedFeature.NoteCreate,
    });
  };

  useEffectOnMount(() => {
    trackEvent(TrackedEvent.FeatureGateBannerView, { level });
  });

  const iconDanger = theme.colors.icon.danger;

  return (
    <>
      <div>
        <MDSBanner
          kind={bannerKind}
          iconKind={iconKind ?? MdsIconKind.InfoCircle}
          message={message}
          iconColor={bannerKind === MDSBannerKind.Error ? iconDanger : undefined}
        >
          <MDSButton
            slot={MDSBannerSlotName.Right}
            variant={buttonVariant}
            onClick={handleButtonClick}
          >
            {buttonText}
          </MDSButton>
        </MDSBanner>
      </div>
    </>
  );
};
